export default {
  init() {
    // JavaScript to be fired on the home page

    var item = document.querySelector('.imagebroschuere');
    window.setTimeout(function(){
          item.classList.add('animation-roll');
    }, 2000);

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js